import { useSelector, useDispatch } from "react-redux";
import {
  Card,
  Grid,
  CardContent,
  Fab,
  CardActionArea,
  Button,
  Typography,
  Box,
  Stack,
} from "@mui/material";
import React from "react";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { Color, FontStyle } from "../constants";
import { fileSizeToString } from "../utils/utils";
import CloseIcon from "@mui/icons-material/Close";

const styles = {
  dragScreen: {
    // backgroundColor: "green",
    position: "absolute",
    width: "100%",
    height: "100%",
    borderRadius: "1rem",
    top: "0px",
    right: "0px",
    bottom: "0px",
    left: "0px",
    backgroundColor: Color.primary + "80",
  },
};

const maxMb = 4;
const maxMbString = maxMb + " MB";
const maxMbInt = maxMb * 1000000;

const UploadSign = ({ label }) => {
  return (
    <Stack
      direction="column"
      sx={{ width: "100%" }}
      spacing={1}
      alignItems="center"
      justifyContent="center">
      <UploadFileIcon sx={{ fontSize: "48px" }} />
      <Box
        sx={{
          ...FontStyle.headingBody,
          fontSize: "18px",
        }}>
        Drag {label} here
      </Box>
      <Box
        sx={{
          ...FontStyle.body,
          fontSize: "14px",
          color: "#aaa",
        }}>
        or, click to browse (.pdf, .docx, .doc, and .txt files)
      </Box>
    </Stack>
  );
};
const UploadedFile = ({ name, size, clearFile }) => {
  return (
    <Stack
      direction="row"
      sx={{ width: "100%", px: 2, ...FontStyle.body }}
      spacing={1}
      alignItems="center"
      justifyContent="space-between">
      <Stack
        direction="column"
        sx={{ width: "100%" }}
        spacing={0.5}
        alignItems="flex-start">
        <Box>{name}</Box>
        <Box
          sx={{
            fontSize: "14px",
            color: "#aaa",
          }}>
          Size: {fileSizeToString(size)}
        </Box>
      </Stack>
      <Button
        sx={{
          fontSize: "12px",
          padding: "0px",
          minWidth: "0px",
          minHeight: "0px",
          lineHeight: "1",
          color: Color.deepPurple,
          textTransform: "none",
          "&:hover": {
            textDecoration: "underline",
          },
        }}
        onClick={clearFile}>
        Remove
      </Button>
    </Stack>
  );
};

const uploadFile = (handleUpload, file) => {
  const size = file.size;
  console.log("size", size);
  console.log("file", file);
  if (size > maxMbInt) {
    alert("File size must be less than " + maxMbString);
    return;
  }
  //   const acceptedTypes

  const reader = new FileReader();
  reader.onloadend = () => {
    handleUpload(reader.result, file.name, file.size, file);
  };
  reader.readAsDataURL(file);
};

const acceptedTypes = ["pdf", "doc", "docx", "txt"];
const acceptStr = acceptedTypes.map((type) => "." + type).join(",");
// console.log("accepted", acceptStr);
const FettiFileUpload = ({
  label,
  file,
  setFile,
  canClose = false,
  onClose = null,
}) => {
  const [hovered, setHovered] = React.useState(false);
  // drag state
  const [dragActive, setDragActive] = React.useState(false);
  // handle drag events
  const handleUpload = (data, name, size, rawFile) => {
    setFile({
      data: rawFile,
      name,
      size,
    });
  };

  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };
  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      console.log("dragged", e.dataTransfer.files[0].type);
      // check file type
      const fileType = e.dataTransfer.files[0].name.split(".")[1];
      if (!acceptedTypes.includes(fileType)) {
        alert("File type must be one of: " + acceptStr);
        return;
      }

      uploadFile(handleUpload, e.dataTransfer.files[0]);
    }
  };
  const handleChange = function (e) {
    console.log("file change", e);
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      uploadFile(handleUpload, e.target.files[0]);
    }
  };
  const clearFile = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setFile({
      data: null,
      name: "",
      size: 0,
    });
  };
  return (
    <Box
      sx={{
        width: "100%",
        // height: "100px",
        // backgroundColor: "red",
        position: "relative",
      }}
      onMouseEnter={() => {
        setHovered(true);
      }}
      onMouseLeave={() => setHovered(false)}>
      {canClose && (
        <Stack
          alignItems="center"
          justifyContent="center"
          onClick={onClose}
          sx={{
            position: "absolute",
            top: "8px",
            right: "8px",
            zIndex: "1",
            display: hovered ? "block" : "none",
            cursor: "pointer",
            backgroundColor: "#f008",
            color: "white",
            height: "19px",
            width: "19px",
            borderRadius: "50%",
            transition: "all 0.2s ease-in-out",
            "&:hover": {
              backgroundColor: "#f00",
            },
          }}>
          <CloseIcon
            sx={{
              width: "14px",
              height: "14px",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          />
        </Stack>
      )}
      <form
        onDragEnter={handleDrag}
        onSubmit={(e) => e.preventDefault()}
        style={{
          width: "100%",
          height: "100%",
          //   backgroundColor: "blue",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",

          borderWidth: "2px",
          borderRadius: "1rem",
          borderStyle: "dashed",
          borderColor: file.data ? Color.deepPurple : Color.fettiPurple,
          position: "relative",
        }}>
        <input
          type="file"
          id="input-file-upload"
          accept={acceptStr}
          style={{ display: "none" }}
          onChange={handleChange}
        />
        <label
          id="label-file-upload"
          htmlFor="input-file-upload"
          style={{
            width: "100%",
            cursor: "pointer",
            paddingTop: "12px",
            paddingBottom: "12px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // backgroundColor: "green",
          }}>
          {file.data ? (
            <UploadedFile
              name={file.name}
              size={file.size}
              clearFile={clearFile}
            />
          ) : (
            <UploadSign label={label} />
          )}
        </label>
        {dragActive && (
          <div
            style={styles.dragScreen}
            onDragEnter={handleDrag}
            onDragLeave={handleDrag}
            onDragOver={handleDrag}
            onDrop={handleDrop}></div>
        )}
      </form>
    </Box>
  );
};

export default FettiFileUpload;
